import { FC } from "react";
import { NotificationRow } from "entities/notification";
import type { NotificationItem, NotificationType } from "entities/notification";
import { InfiniteList } from "shared/ui";
import { useInboxSection } from "../model/useInboxSection";

interface Props {
  type: NotificationType;
  onItemClick: (item: NotificationItem) => void;
}

export const InboxList: FC<Props> = ({ type, onItemClick }) => {
  const list = useInboxSection(type);

  return (
    <InfiniteList
      {...list}
      emptyText="No notifications yet"
      getKey={(item) => item.id}
      renderItem={(item) => (
        <NotificationRow item={item} onClick={onItemClick} />
      )}
    />
  );
};
